<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/document.webp"
  >
    <ng-container i18n
      >Streamline contracts and approvals with Document Sign. Track status, notify parties, log activity, and automate
      follow-ups seamlessly. Stay informed and keep workflows efficient.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to notify the</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="notifyType = 'signer'"
          class="btn btn-sm"
          [ngClass]="notifyType === 'signer' ? 'btn-info' : 'btn-outline-light'"
        >
          <ng-container i18n>Signer</ng-container>
        </button>
        <button
          type="button"
          (click)="notifyType = 'user'"
          class="btn btn-sm"
          [ngClass]="notifyType === 'user' ? 'btn-info' : 'btn-outline-light'"
        >
          <ng-container i18n>User</ng-container>
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <app-document-notifications-pref-list [notifyType]="notifyType"></app-document-notifications-pref-list>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <app-document-notifications-pref-table></app-document-notifications-pref-table>
</div>
